import axios from '@/lib/axios';
import { SalesOrder, SalesOrderContractTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1664. 受注案件契約タスクアーカイブ解除
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:id/unarchive
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};
const unarchiveSalesOrderContractTasks = (props: Props): Promise<SalesOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.id}/unarchive`,
    props
  );
};

export const useUnarchiveSalesOrderContractTasks = () => {
  return useMutation({
    mutationFn: unarchiveSalesOrderContractTasks,
  });
};
